
export const flagDemographicsIncorrectGuarantor = (state, {status, error}) => {
    state.guarantor.demographic.flagStatus = status;
    state.guarantor.demographic.error = error;
};